const getInjectedElement = () => {
  return document.getElementById('assembly-extension-info');
};

const getChromeExtensionDataset = () => {
  return getInjectedElement()?.dataset;
};

export const getChromeExtensionId = () => {
  return getChromeExtensionDataset()?.extId;
};

export const getChromeExtensionVersion = () => {
  return getChromeExtensionDataset()?.version;
};

export async function waitForChromeExtensionId(): Promise<string | undefined> {
  return new Promise((resolve) => {
    const timeoutId = setTimeout(resolve, 5000);

    const pollForExtensionId = setInterval(() => {
      if (getInjectedElement()) {
        clearInterval(pollForExtensionId);
        clearTimeout(timeoutId);
        resolve(getChromeExtensionId());
      }
    }, 1000);
  });
}
